import { styled } from '@mui/material'

export const MainContainer = styled('div')(({ theme }) => ({
  minHeight: 776,
  height: '80vh',
  width: 'calc(100% - 4rem - 20px)',
  margin: '2rem',
  border: `10px solid ${theme.palette.backgroundMain}`,
  borderRadius: 6,
  position: 'relative',
  [theme.breakpoints.down(1060)]: {
    minHeight: 500,
    height: 'auto',
    margin: '0 0 2rem 0',
    border: 'none',
    width: '100%',
  },
  '& >div:first-of-type': {
    height: '100%',
    width: '100%',
    [theme.breakpoints.down(1060)]: {
      height: 535,
    },
  },
}))

export const ListContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 10,
  left: 10,
  zIndex: 5,
  height: 'calc(100% - 20px)',
  backgroundColor: theme.palette.common.white,
  borderRadius: 6,
  [theme.breakpoints.down(1060)]: {
    position: 'relative',
    left: 0,
    width: '100%',
    height: '70%',
  },
  '& >div.content': {
    overflow: 'auto',
    height: 'calc(100% - 117px)',
    [theme.breakpoints.down(1060)]: {
      height: '100%',
    },
  },
  '& >div.loader': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto',
    height: 'calc(100% - 117px)',
    [theme.breakpoints.down(1060)]: {
      height: 'calc(100% - 117px)',
    },
  },
}))

export const MapLegend = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 10,
  right: 66,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.common.black}`,
  borderRadius: 6,
  padding: 4,
  '& >div': {
    display: 'flex',
    alignItems: 'center',
    '& >p': {
      fontSize: 13,
      color: theme.palette.common.black,
    },
  },
  '& >div:first-of-type': {
    color: theme.palette.primary.main,
  },
  '& >div:last-of-type': {
    color: theme.palette.primary.light,
    stroke: theme.palette.primary.main,
    strokeWidth: 1,
  },
}))
